var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4992_8557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5375 12C13.5375 15.7275 10.5075 18.75 6.768 18.75C5.8804 18.7512 5.00125 18.5775 4.18076 18.239C3.36026 17.9004 2.61449 17.4035 1.98603 16.7767C1.35756 16.1499 0.858704 15.4055 0.517941 14.5859C0.177178 13.7663 0.00118111 12.8876 0 12C0 8.27101 3.03 5.25001 6.768 5.25001C7.65573 5.24863 8.53504 5.42214 9.3557 5.76063C10.1764 6.09912 10.9223 6.59596 11.5509 7.22278C12.1796 7.84959 12.6786 8.5941 13.0194 9.41379C13.3603 10.2335 13.5363 11.1123 13.5375 12V12ZM20.9625 12C20.9625 15.51 19.4475 18.354 17.5785 18.354C15.7095 18.354 14.1945 15.5085 14.1945 12C14.1945 8.49001 15.7095 5.64601 17.5785 5.64601C19.4475 5.64601 20.9625 8.49151 20.9625 12ZM24 12C24 15.144 23.4675 17.6925 22.809 17.6925C22.152 17.6925 21.6195 15.1425 21.6195 12C21.6195 8.85601 22.152 6.30751 22.8105 6.30751C23.4675 6.30751 24 8.85601 24 12Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4992_8557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.1bad6fc1064dce531eac0bb0897fabb9.svg";
export { ForwardRef as ReactComponent };